<template>
  <v-dialog v-model="dialog" persistent transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Seleccione el proyecto para la siglo XX</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-combobox
              v-model="filtroestudiante"
              label="Buscar por Codigo de proyecto"
              :items="estudiantes"
              :loading="isloadingestudent"
              loader-height="4"
              placeholder="tecla enter para buscar..."
              hide-details
              outlined
              return-object
              dense
            ></v-combobox>

            <div v-if="typeof filtroestudiante == 'object'">
              <p class="mb-0 mt-4"><b class="blue--text">Codigo:</b> {{ filtroestudiante.codigo }}</p>
              <p class="mb-0"><b class="blue--text">Proyecto:</b> {{ filtroestudiante.programa }}</p>
              <p class="mb-0"><b class="blue--text">Gestion:</b> {{ filtroestudiante.gestion }}</p>
              <p class="mb-0"><b class="blue--text">Version:</b> {{ filtroestudiante.version }}</p>
              <p class="mb-0"><b class="blue--text">Area:</b> {{ filtroestudiante.area }}</p>
              <p class="mb-0"><b class="blue--text">Fecha inicio:</b> {{ filtroestudiante.fecha_inicio }}</p>
              <p class="mb-0"><b class="blue--text">Fecha culminacion:</b> {{ filtroestudiante.fecha_culminacion }}</p>
              <p class="mb-0">
                <b class="blue--text">Estado Proyecto:</b>
                <b :class="'ma-0 pa-0 ' + getestadopuntito(filtroestudiante.estado_programa)">
                  ({{ filtroestudiante.estado_programa }}) {{ getestadoprograma(filtroestudiante.estado_programa) }}
                </b>
              </p>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        timeoutHnd: 0,
        filtroestudiante: '',
        isloadingestudent: false,
        estudiantes: [],
      };
    },
    components: {},
    watch: {
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          this.getDatos();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      openmodal() {
        this.filtroestudiante = '';
        this.dialog = true;
      },
      getDatos() {
        //window.console.log('DATOS::::', this.filtroestudiante);
        this.$emit('proyectosel', this.filtroestudiante);
      },
      getestadoprograma(estado) {
        if (estado == 1) return 'Creado';
        else if (estado == 2) return 'Aprobado';
        else if (estado == 3) return 'Rechazado';
      },
      getestadopuntito(estado) {
        if (estado == 1) return 'puntito1';
        else if (estado == 2) return 'puntito2';
        else if (estado == 3) return 'puntito3';
        return 'puntito1';
      },
      asyncfindestudiante() {
        this.isloadingestudent = true;
        const vue = this;
        let codigo = this.filtroestudiante;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx/${codigo}`;
        //let url = `http://localhost:8090/api/v1/programa-unsxx/${codigo}`;
        var config = {
          method: 'get',
          url: url,
        };

        xaxios.request(config)
          .then(function(response) {
            if (!response.data.data) response.data.data = [];
            response.data.data.map((x) => {
              x.text = `(${x.codigo}) ${x.programa}`;
            });
            vue.estudiantes = response.data.data;
            //window.console.log(JSON.stringify(response.data.data));
            vue.isloadingestudent = false;
          })
          .catch(function(error) {
            vue.isloadingestudent = false;
            window.console.log(error);
          });
      },
    },
  };
</script>
